import React from 'react';

const Landingpage: React.FC = () => {

    return (<div>
        <h1>Content on Demand</h1>
    </div>)
};

export default Landingpage;